import navServicesMegaData from "@/data/nav-services-mega.json";
import type { NavServicesMegaData } from "@/lib/cc-nav-services-mega";

const megaData = navServicesMegaData as unknown as NavServicesMegaData;

/** Public slugs and their aliases come from the canonical navigation JSON. */
export function getServiceSubpageSlug(serviceTag: string, subKey: string, locale: string): string {
  const link = megaData.columns[serviceTag]?.links.find((item) => item.key === subKey);
  return link?.slug?.[locale] ?? subKey;
}

/** Mega-menu sub-page slug under AI Automation (hero announcement target). */
export const HUBSPOT_AUTOMATIONS_SUBPAGE_KEY = "hubspot";

const LEGACY_SERVICE_SUBPAGE_SLUGS: Record<string, Record<string, string>> = {
  "web-design": {
    varumarke: "branding",
    "landing-pages": "landningssida",
  },
  "ai-automation": {
    "hubspot-automations": HUBSPOT_AUTOMATIONS_SUBPAGE_KEY,
    "crm-integration": "systemintegration",
  },
  sem: {
    sem: "google-ads",
  },
  seo: {
    "local-seo": "lokal-seo",
  },
};

/** Whether `subKey` is a registered placeholder sub-page for `serviceTag`. */
export function isRegisteredServiceSubpage(
  serviceTag: string,
  subKey: string,
): boolean {
  const column = megaData.columns[serviceTag];
  if (!column) {
    return false;
  }
  return column.links.some((link) => link.key === subKey);
}

/** Maps legacy URL segments to current mega-menu `key` values. */
export function resolveServiceSubpageKey(
  serviceTag: string,
  urlSegment: string,
): string | null {
  const legacy = LEGACY_SERVICE_SUBPAGE_SLUGS[serviceTag]?.[urlSegment];
  const localized = megaData.columns[serviceTag]?.links.find((link) =>
    Object.values(link.slug ?? {}).includes(urlSegment),
  )?.key;
  const key = legacy ?? localized ?? urlSegment;
  return isRegisteredServiceSubpage(serviceTag, key) ? key : null;
}

/** Tool landing pages live outside their service hub in the sitemap plan. */
export function isStandaloneServiceSubpage(tag: string, key: string, locale: string): boolean {
  return megaData.columns[tag]?.links.find(link => link.key === key)?.standaloneLocales?.includes(locale) ?? false;
}

export function resolveStandaloneServiceSubpage(segment: string, locale: string): {serviceTag: string; subKey: string} | null {
  for (const [serviceTag, column] of Object.entries(megaData.columns)) {
    for (const link of column.links) {
      if (link.standaloneLocales?.includes(locale) && (getServiceSubpageSlug(serviceTag, link.key, locale) === segment || link.key === segment)) {
        return {serviceTag, subKey: link.key};
      }
    }
  }
  return null;
}
